var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "UserPreferencesForm",
    _vm._b(
      {
        key: _vm.notificationPreferencesKey,
        ref: "form",
        on: {
          reset: function ($event) {
            return _vm.$emit("reset")
          },
          success: function ($event) {
            return _vm.$emit("success")
          },
          editing: function ($event) {
            return _vm.$emit("editing", $event)
          },
          submit: function ($event) {
            return _vm.$emit("submit")
          },
        },
      },
      "UserPreferencesForm",
      _vm.$props,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }